import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendar, FaUser, FaArrowRight } from 'react-icons/fa';

const BlogCard = ({ blog }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div className="card card-hover group">
      {/* Featured Image */}
      <div className="relative h-56 overflow-hidden">
        {blog.featured_image ? (
          <img
            src={blog.featured_image}
            alt={blog.title}
            className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-primary-400 to-secondary-400 flex items-center justify-center">
            <span className="text-white text-7xl font-bold opacity-20">
              {blog.title.charAt(0)}
            </span>
          </div>
        )}
        {blog.category && (
          <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-primary-700">
            {blog.category}
          </div>
        )}
      </div>

      {/* Blog Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {blog.title}
        </h3>

        <div className="flex items-center gap-4 text-xs text-gray-500 mb-4">
          <div className="flex items-center">
            <FaCalendar className="mr-2" />
            {formatDate(blog.published_at)}
          </div>
          {blog.author && (
            <div className="flex items-center">
              <FaUser className="mr-2" />
              {blog.author}
            </div>
          )}
        </div>

        <p className="text-gray-600 text-sm mb-4 line-clamp-3">
          {blog.excerpt || 'Click to read more about this interesting topic...'}
        </p>

        <Link
          to={`/blogs/${blog.slug}`}
          className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium text-sm group-hover:gap-2 transition-all"
        >
          Read More
          <FaArrowRight className="ml-1 transform group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
